module.exports = __webpack_public_path__ + "static/media/signin-password-icon.52a7b4e9.svg";